import { useMemo } from 'react';
import qs from 'query-string';
import { useSsrRequest } from 'app/context/common/SsrRequestProvider';
import { isBrowser } from 'app/libs/environment';

function useSsrWindowLocation() {
	const req = useSsrRequest();

	return useMemo(() => {
		if (isBrowser) return window.location;

		const protocol = `${req.protocol}:`;
		const host = req.get('host');
		const { hostname } = req;
		const pathname = req.path;
		const search = Object.keys(req.query).length === 0 ? '' : `?${qs.stringify(req.query)}`;

		return {
			protocol,
			host,
			hostname,
			pathname,
			search,
		};
	}, [req]);
}

export default useSsrWindowLocation;
